import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';
import {
  CHARGEBACKS_FINAL_TABS,
  CHARGEBACKS_MAIN_TABS,
  CHARGEBACKS_PROGRESS_TABS
} from './i18.chargebacks';

const ChargebacksTable = lazy(
  () => import(/* webpackChunkName: "LuciRoutes" */ './ChargebacksTableDisplay')
);

const UFSharedNestedView = lazy(
  () =>
    import(
      /* webpackChunkName: "LuciRoutes" */ '../components/UFSharedNestedView'
    )
);

export const chargebacksRoutes: PageRouter[] = [
  {
    name: CHARGEBACKS_MAIN_TABS.NEW,
    path: `/${CHARGEBACKS_MAIN_TABS.NEW}`,
    exact: false,
    component: ChargebacksTable,
    tabs: []
  },
  {
    name: CHARGEBACKS_MAIN_TABS.IN_PROGRESS,
    path: `/${CHARGEBACKS_MAIN_TABS.IN_PROGRESS}`,
    component: UFSharedNestedView,
    exact: false,
    tabs: [
      {
        name: CHARGEBACKS_PROGRESS_TABS.DISPUTE,
        path: `/${CHARGEBACKS_PROGRESS_TABS.DISPUTE}`,
        component: ChargebacksTable,
        exact: true
      },
      {
        name: CHARGEBACKS_PROGRESS_TABS.PROCESSING,
        path: `/${CHARGEBACKS_PROGRESS_TABS.PROCESSING}`,
        component: ChargebacksTable,
        exact: true
      }
    ]
  },
  {
    name: CHARGEBACKS_MAIN_TABS.FINAL,
    path: `/${CHARGEBACKS_MAIN_TABS.FINAL}`,
    component: UFSharedNestedView,
    exact: false,
    tabs: [
      {
        name: CHARGEBACKS_FINAL_TABS.LOSS,
        path: `/${CHARGEBACKS_FINAL_TABS.LOSS}`,
        component: ChargebacksTable,
        exact: true
      },
      {
        name: CHARGEBACKS_FINAL_TABS.RECOVERED,
        path: `/${CHARGEBACKS_FINAL_TABS.RECOVERED}`,
        component: ChargebacksTable,
        exact: true
      }
    ]
  }
];
